//#region IMPORT
import React, { useRef, useState } from 'react';
import { Button, Dialog } from '../MUIs';
import { AppBar, Box, IconButton, Toolbar, Typography } from '@mui/material';
import {
  Close as CloseIcon,
  Search as SearchIcon,
  Add as AddIcon,
  Save as SaveIcon,
  Delete as DeleteIcon,
  Print as PrintIcon,
} from '@mui/icons-material';
import { BusinessGridCommon } from '../BusinessGridCommon';
import { newYnErrorSnackbar } from '../../Reducer/SnackbarReducer';
import GridCheckBox from '../Ui/GridCheckBox/GridCheckBox';
import GridCellFileUpload from '../Ui/GridCellFileUpload/GridCellFileUpload';
import { GridFileUploadF } from '../Ui/GridFileUpload/GridFileUploadF';
//#endregion

function FileModalCommon(props) {
  //#region 변수
  //#endregion

  //#region 웹
  const columnDefs1 = [
    {
      headerCheckboxSelection: true,
      field: 'no',
      headerName: 'NO',
      maxWidth: 100,
      cellStyle: {
        textAlign: 'right',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      },
      editable: false,
      cellClass: 'delete-action-cell',
      cellRenderer: (params) => {
        return (
          <GridCheckBox
            params={params}
            DeleteNewRow={props.DeleteNewRow1}
            RestoreRow={props.RestoreRow1}
            gridRef={props.gridRef1}
            rowData={props.rowData1}
            selectedRowNosRef={props.selectedRowNosRef1}
            lastCheckedIndexRef={props.lastCheckedIndexRef1}
            handleRowSelection={props.HandleRowSelection}
          />
        );
      },
    },
    {
      field: 'CUST_CD',
      headerName: '사업장코드',
      minWidth: 100,
      editable: false,
      hide: true,
      cellStyle: {
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
      }, // 셀 자체 왼쪽 정렬
    },
    {
      field: 'FILE_NAME',
      headerName: '파일명',
      minWidth: 100,
      editable: false,
      flex: 1,
      cellStyle: {
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
      }, // 셀 자체 왼쪽 정렬
      cellClassRules: {
        'required-cell': (params) =>
          !params.value || params.value.trim() === '',
      },
    },
    {
      field: 'DATE',
      headerName: '작성일',
      cellEditor: 'agDateStringCellEditor',
      valueFormatter: (params) => {
        const date = new Date(params.value);
        if (isNaN(date.getTime())) return '';

        const year = date.getFullYear();
        const month = (date.getMonth() + 1).toString().padStart(2, '0'); // 1을 더해서 월을 1-12로 맞추고, 2자리로 포맷
        const day = date.getDate().toString().padStart(2, '0'); // 일자도 2자리로 포맷

        return `${year}-${month}-${day}`;
      },
      valueParser: (params) => {
        const [year, month, day] = params.newValue.split('-');
        const parsedDate = new Date(
          Date.UTC(year, month - 1, day)
        ).toISOString();

        // 이전 값과 같으면 그대로 반환
        if (parsedDate.substr(0, 10) === params.oldValue?.substr(0, 10)) {
          return params.oldValue;
        }

        return parsedDate;
      },
      editable: true,
      minWidth: 100,
      cellStyle: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }, // 셀 자체 가운데 정렬
      cellClassRules: {
        'required-cell': (params) =>
          !params.value || params.value.trim() === '',
      },
    },
    // 업로드는 따로 버튼 두지말고 파일명 컬럼에서 처음등록할때는 버튼, 등록되면 파일이름 보여주고 업데이트 할때는 a태그로 된 이름 클릭하면 업로드 할 수 있게끔
    // {
    //   field: 'upload',
    //   headerName: '파일 업로드',
    //   pinned: 'right',
    //   width: 130,
    //   editable: false,
    //   cellRenderer: (e) => {
    //     return (
    //       <GridCellFileUpload
    //         label="업로드"
    //         extension=""
    //         gridRef={props.gridRef1}
    //         e={e}
    //         props={props}
    //       />
    //     );
    //   },
    //   cellStyle: {
    //     display: 'flex',
    //     justifyContent: 'center',
    //     alignItems: 'center',
    //   }, // 셀 자체 가운데 정렬
    // },
    {
      field: 'download',
      headerName: '파일 다운로드',
      pinned: 'right',
      width: 140,
      editable: false,
      cellRenderer: (e) => {
        return (
          <Button
            size="small"
            name={'파일 다운로드'}
            sx={{ width: '100%' }}
            onClick={() => {
              props.DownloadLogic1(e.data);
            }}
          />
        );
      },
      cellStyle: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }, // 셀 자체 가운데 정렬
    },
    {
      field: 'CREATE_ID',
      headerName: '작성자',
      minWidth: 100,
      editable: false,
      hide: true,
      cellStyle: {
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
      }, // 셀 자체 왼쪽 정렬
    },
    {
      field: 'mapBlob',
      headerName: '블롭',
      minWidth: 100,
      editable: false,
      hide: true,
      cellStyle: {
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
      }, // 셀 자체 왼쪽 정렬
    },
    {
      field: 'mapFile',
      headerName: '파일',
      minWidth: 100,
      editable: false,
      hide: true,
      cellStyle: {
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
      }, // 셀 자체 왼쪽 정렬
    },
    {
      field: 'mapFileName',
      headerName: '파일명(사용자가 올린 이름)',
      minWidth: 100,
      editable: false,
      hide: true,
      cellStyle: {
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
      }, // 셀 자체 왼쪽 정렬
    },
    {
      field: 'SAVE_NAME',
      headerName: '파일명(저장되는 이름)',
      minWidth: 100,
      editable: false,
      hide: true,
      cellStyle: {
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
      }, // 셀 자체 왼쪽 정렬
    },
  ];
  //#endregion

  return (
    <>
      {props.open && (
        <div
          role="presentation"
          className="MuiDialog-root MuiModal-root"
          inert="true"
        >
          <Dialog
            title={props.modalTitle}
            open={props.open}
            onClose={props.onClose}
            contentSx={{ display: 'flex', flexDirection: 'column' }}
            fullWidth
            saveButtonName={'저장'}
            closeButtonName={'닫기'}
            useSaveButton={true}
            useSaveAfterClose={false}
            maxWidth="md"
            onSave={() => {
              props.SaveLogic1();
            }}
            content={
              <div
                className="ag-theme-alpine no-scroll"
                style={{ height: '600px', width: '100%' }}
              >
                <BusinessGridCommon
                  getRowId={(params) => {
                    return params.data.no;
                  }}
                  gridRef={props.gridRef1}
                  columnDefs={columnDefs1}
                  rowData={props.rowData1}
                  setSelectedRowData={props.setSelectedRowData1}
                  setChangedRowData={props.setChangedRowData1}
                  title1={props.gridTitle}
                  rowSelection={'multiple'}
                  addClick1={() => {
                    GridFileUploadF(props.extension, props.gridRef1, props);
                  }}
                  deleteClick1={(e) => {
                    const newRowExists = props.selectedRowData1.some(
                      (row) => row.newYn === 'Y'
                    );

                    if (!newRowExists) {
                      props.MarkedForDeletion1(props.selectedRowData1);
                    } else {
                      newYnErrorSnackbar();
                    }
                  }}
                  refreshClick1={(e) => props.SearchLogic1()}
                  onCellClicked={(e) => {
                    const gridApi = props.gridRef1.current.api;
                    const clickedRowIndex = e.rowIndex;

                    const isCheckboxClick =
                      e.event?.target?.type === 'checkbox';

                    if (!isCheckboxClick) {
                      gridApi.ensureIndexVisible(clickedRowIndex, 'middle');
                      gridApi.setFocusedCell(clickedRowIndex, 'coNm');

                      const copied = JSON.parse(JSON.stringify(e.data));
                      props.HandleRowSelection(copied, clickedRowIndex);

                      gridApi
                        .getDisplayedRowAtIndex(clickedRowIndex)
                        ?.setSelected(true, false);
                    }
                  }}
                  onSelectionChanged={() => {
                    const gridApi = props.gridRef1?.current?.api;
                    const selectedNodes = gridApi.getSelectedNodes();
                    const selectedData = selectedNodes.map((n) => n.data);
                    props.selectedRowNosRef1.current = new Set(
                      selectedData.map((r) => r.no)
                    );
                    props.setSelectedRowData1(selectedData);
                  }}
                  onCellValueChanged={(e) => {
                    const key = e.data.no;

                    props.setChangedRowData1?.((prev) => {
                      const filtered = prev.filter((row) => row.no !== key);
                      return [...filtered, { ...e.data, newYn: 'Y' }];
                    });
                  }}
                  other1={
                    <Button
                      name="멀티 다운로드"
                      size="small"
                      sx={{ m: 1 }}
                      onClick={() => {
                        // 그리드에 데이터가 없는 경우
                        if (!props.rowData1 || props.rowData1.length === 0) {
                          props.dispatch(
                            props.showSnackbar({
                              message: '파일 업로드 후 다운로드가 가능합니다.',
                              type: 'warning',
                            })
                          );
                          return;
                        }
                        // 선택된 항목이 없는 경우
                        if (
                          !props.selectedRowData1 ||
                          props.selectedRowData1.length === 0
                        ) {
                          props.dispatch(
                            props.showSnackbar({
                              message: '항목을 선택해주세요.',
                              type: 'warning',
                            })
                          );
                          return;
                        }
                        props.selectedRowData1.forEach((item, index) => {
                          props.DownloadLogic1(item);
                        });
                      }}
                    />
                  }
                />
              </div>
            }
            // useCloseButton={false}
            // onSave={() => {}}
            // maxWidth="sm"
          />
        </div>
      )}
    </>
  );
}

export default FileModalCommon;
